export default "__VITE_ASSET__DA4bfB_X__"